import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import {APP_BASE_HREF} from '@angular/common';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';



import { AppComponent } from './app.component';
import { AllComponent } from './appviews/all/all.component';
import { MasksComponent } from './appviews/masks/masks.component';
import { ClothingComponent } from './appviews/clothing/clothing.component';
import { SanitizersComponent } from './appviews/sanitizers/sanitizers.component';
import { KitsComponent } from './appviews/kits/kits.component';
import { GlovesComponent } from './appviews/gloves/gloves.component';
import { ProductComponent } from './appviews/product/product.component';
import { VentilatorsComponent } from './appviews/ventilators/ventilators.component';
import { NavComponent } from './appviews/nav/nav.component';
import { FooterComponent } from './appviews/footer/footer.component';
import { TabsComponent } from './appviews/tabs/tabs.component';
import { RecommendedComponent } from './appviews/recommended/recommended.component';
import { AboutComponent } from './appviews/about/about.component';
import { ContactComponent } from './appviews/contact/contact.component';
import { M31826Component } from './appviews/m31826/m31826.component';
import { KitAllplexComponent } from './appviews/kit-allplex/kit-allplex.component';
import { KitMedakitComponent } from './appviews/kit-medakit/kit-medakit.component';
import { VentYH830Component } from './appviews/vent-yh830/vent-yh830.component';
import { VentVG70Component } from './appviews/vent-vg70/vent-vg70.component';
import { Mask3m8210Component } from './appviews/mask3m8210/mask3m8210.component';
import { MaskKN95Component } from './appviews/mask-kn95/mask-kn95.component';
import { Mask3m1860Component } from './appviews/mask3m1860/mask3m1860.component';
import { Mask3PlyComponent } from './appviews/mask3-ply/mask3-ply.component';
import { MaskN95Component } from './appviews/mask-n95/mask-n95.component';
import { MaskN95NioshComponent } from './appviews/mask-n95-niosh/mask-n95-niosh.component';
import { MaskFaceShieldComponent } from './appviews/mask-face-shield/mask-face-shield.component';
import { MaskGogglesComponent } from './appviews/mask-goggles/mask-goggles.component';
import { Sanitizer16Component } from './appviews/sanitizer16/sanitizer16.component';
import { SanitizerGallonComponent } from './appviews/sanitizer-gallon/sanitizer-gallon.component';
import { GownSurgicalComponent } from './appviews/gown-surgical/gown-surgical.component';
import { GownIsolationComponent } from './appviews/gown-isolation/gown-isolation.component';

@NgModule({
  declarations: [
    AppComponent,
    AllComponent,
    MasksComponent,
    ClothingComponent,
    SanitizersComponent,
    KitsComponent,
    GlovesComponent,
    ProductComponent,
    VentilatorsComponent,
    NavComponent,
    FooterComponent,
    TabsComponent,
    RecommendedComponent,
    AboutComponent,
    ContactComponent,
    M31826Component,
    KitAllplexComponent,
    KitMedakitComponent,
    VentYH830Component,
    VentVG70Component,
    Mask3m8210Component,
    MaskKN95Component,
    Mask3m1860Component,
    Mask3PlyComponent,
    MaskN95Component,
    MaskN95NioshComponent,
    MaskFaceShieldComponent,
    MaskGogglesComponent,
    Sanitizer16Component,
    SanitizerGallonComponent,
    GownSurgicalComponent,
    GownIsolationComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule
  ],
  providers: [{provide: APP_BASE_HREF, useValue: '/'}
  // , {provide: LocationStrategy, useClass: HashLocationStrategy}
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
